import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import DbsBankInfoAddForm from "../Forms/DbsBankInfoAddForm";
import DbsBankInfoUpdateForm from "../Forms/DbsBankInfoUpdateForm";

import { Table, Empty, Popconfirm, Col, Row, Drawer } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

function DbsInfo(props) {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
  });

  const [addFormVisibility, setAddFormVisibility] = useState(false);
  const [updateFormVisibility, setUpdateFormVisibility] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});

  useEffect(() => getTableData(), [tableDataQueryOptions]);

  useEffect(() => {
    if (props.addButtonEvent > 0) {
      setAddFormVisibility(true);
    }
  }, [props.addButtonEvent]);

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    const { skip, take } = tableDataQueryOptions;

    RequestHandler.get(
      `/DbsBankInfo?$count=true&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setTableData({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });
  };

  const getUpdateFormData = (id) => {
    RequestHandler.get(`/DbsBankInfo/GetById/${id}`).then((response) => {
      if (response) {
        response.currencyIds = [];
        response.currencies.forEach((element) => {
          response.currencyIds.push(element.currencyId);
        });

        setUpdateFormData(response);
        setUpdateFormVisibility(true);
      }
    });
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const handleOnClickDelete = (id) => {
    RequestHandler.delete(`/DbsBankInfo/${id}`).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  const onAddFormSuccess = () => {
    getTableData();
    setAddFormVisibility(false);
  };

  const onUpdateFormSuccess = () => {
    getTableData();
    setUpdateFormVisibility(false);
  };

  const columns = [
    {
      title: "Banka",
      dataIndex: "bankLogo",
      key: "bankLogo",
      width: "8%",
      render: (text, row, index) => {
        {
          if (text === "KASA HESABI") {
            return <img src={row.bankLogo}></img>;
          }
          return <img src={row.bankLogo}></img>;
        }
      },
    },
    {
      title: "Kullanıcı Adı",
      dataIndex: "userName",
    },
    {
      title: "Dbs Numarası",
      dataIndex: "dbsCode",
    },
    {
      title: "Opsiyonel Dbs Numarası",
      dataIndex: "optionalDbsCode",
    },
    {
      title: "Düzenle",
      width: "1%",
      align: "center",
      render: (data, row) => (
        <a onClick={() => getUpdateFormData(row.id)}>
          <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
        </a>
      ),
    },
    {
      title: "Sil",
      dataIndex: "operation",
      width: "1%",
      align: "center",
      render: (text, row) => (
        <Popconfirm
          title="Silmek istiyor musunuz?"
          okText="Evet"
          cancelText="Hayır"
          onConfirm={() => handleOnClickDelete(row.id)}
        >
          <a>
            <DeleteOutlined style={{ color: "red", fontSize: "130%" }} />
          </a>
        </Popconfirm>
      ),
    },
  ];

  return (
    <>
      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>

      <Drawer
        id="addDrawer"
        title="Dbs Ekle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setAddFormVisibility(false)}
        visible={addFormVisibility}
      >
        <DbsBankInfoAddForm onSuccess={onAddFormSuccess} />
      </Drawer>

      <Drawer
        id="updateDrawer"
        title="Dbs Güncelle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdateFormVisibility(false)}
        visible={updateFormVisibility}
      >
        <DbsBankInfoUpdateForm
          data={updateFormData}
          onSuccess={onUpdateFormSuccess}
        />
      </Drawer>
    </>
  );
}

export default DbsInfo;
